import sitesAndLocationDataConfigApi from '@/api/config/sitesAndLocationDataConfigApi'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { Site } from '@/types/siteLocation'
import { QueryOptions, useQuery, UseQueryResult } from '@tanstack/react-query'

function useSearchSiteLocation(
  searchParams: SearchParams = {},
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<Site>, any> {
  return useQuery(
    [queryKeys.siteLocation, searchParams],
    async () => {
      const { data } = await sitesAndLocationDataConfigApi.getByInterfaceId({
        ...searchParams,
      })

      if (!data) return null

      return {
        list: data.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchSiteLocation
